import { KeyValue } from '@angular/common';
import { UserRole } from './auth.enums';
import { QuestionType } from './question.enums';

export enum CoursePublicationStatus {
  DRAFT = 'DRAFT',
  READY_FOR_PUBLICATION = 'READY_FOR_PUBLICATION',
  PUBLISHED_ON_TRAINING = 'PUBLISHED_ON_TRAINING',
  PUBLISHED_ON_LESSONS = 'PUBLISHED_ON_LESSONS',
}

export function isCoursePublicationStatusAllowed(
  currentPublicationStatus: CoursePublicationStatus,
  newPublicationStatus: CoursePublicationStatus
) {
  if (currentPublicationStatus === CoursePublicationStatus.DRAFT) {
    return newPublicationStatus === CoursePublicationStatus.READY_FOR_PUBLICATION;
  }
  return true;
}

export enum FeaturedTestimonyPublicationStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  PUBLISHED_ON_LANDING = 'PUBLISHED_ON_LANDING',
}

// nnkitodo [v2later] laisser en draft tant que pas de questions / exam contents / folders / passer en ready for pub quand l'exam est complet par rapport à ce qu'on attend de lui (vérifier aussi conftube, ecos) plutot que de passer en ready direct à la création (exam content c'est fait)
export enum ExamPublicationStatus {
  DRAFT = 'DRAFT',
  READY_FOR_PUBLICATION = 'READY_FOR_PUBLICATION',
  PUBLISHED = 'PUBLISHED',
  PUBLISHED_ON_LANDING = 'PUBLISHED_ON_LANDING',
}

export function isExamPublicationStatusAllowed(
  currentPublicationStatus: ExamPublicationStatus,
  newPublicationStatus: ExamPublicationStatus,
  hasChiefWriterAccess: boolean
) {
  if (!hasChiefWriterAccess) {
    return (
      (currentPublicationStatus === ExamPublicationStatus.DRAFT &&
        newPublicationStatus === ExamPublicationStatus.READY_FOR_PUBLICATION) ||
      (currentPublicationStatus === ExamPublicationStatus.READY_FOR_PUBLICATION &&
        newPublicationStatus === ExamPublicationStatus.DRAFT)
    );
  }
  if (currentPublicationStatus === ExamPublicationStatus.DRAFT) {
    return newPublicationStatus === ExamPublicationStatus.READY_FOR_PUBLICATION;
  }
  return true;
}

export enum ExamGroupPublicationStatus {
  DRAFT = 'DRAFT',
  READY_FOR_PUBLICATION = 'READY_FOR_PUBLICATION',
  PUBLISHED = 'PUBLISHED',
}

export function isExamGroupPublicationStatusAllowed(
  currentPublicationStatus: ExamGroupPublicationStatus,
  newPublicationStatus: ExamGroupPublicationStatus
) {
  if (currentPublicationStatus === ExamGroupPublicationStatus.DRAFT) {
    return newPublicationStatus === ExamGroupPublicationStatus.READY_FOR_PUBLICATION;
  }
  return true;
}

export enum FolderPublicationStatus {
  DRAFT = 'DRAFT',
  READY_FOR_PUBLICATION = 'READY_FOR_PUBLICATION',
}

export enum QuestionPublicationStatus {
  DRAFT = 'DRAFT',
  READY_FOR_PUBLICATION = 'READY_FOR_PUBLICATION',
  PUBLISHED_ON_TRAINING = 'PUBLISHED_ON_TRAINING',
}

export function isQuestionPublicationStatusAllowed(
  currentPublicationStatus: QuestionPublicationStatus,
  newPublicationStatus: QuestionPublicationStatus,
  questionType: QuestionType
) {
  if (questionType === QuestionType.FOLDER) {
    return newPublicationStatus !== QuestionPublicationStatus.PUBLISHED_ON_TRAINING;
  }
  if (currentPublicationStatus === QuestionPublicationStatus.DRAFT) {
    return newPublicationStatus === QuestionPublicationStatus.READY_FOR_PUBLICATION;
  }
  return true;
}

export enum TestimonyPublicationStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}

export function originalOrder(a: KeyValue<string, any>, b: KeyValue<string, any>): number {
  return 0;
}

// nnkitodo [v2later] vérifier les règles sur ces actions, et n'afficher les boutons d'actions que si les règles sont respectées
// add folder question
// delete folder question
// add qi
// delete qi
// associate qi
// dissociate qi
// add folder
// delete folder
// associate folder
// dissociate folder
// add exam content
// delete exam content
// add exam
// delete exam
